import PropTypes from 'prop-types';
import React from 'react';
import { CustomHeader } from '../../incidentForm/fields/customHeader';

const HeaderComponent = ({ field, disabledField }) => {
  return (
    <>
      <CustomHeader field={field} disabled={disabledField} />
    </>
  );
};

export default HeaderComponent;

HeaderComponent.propTypes = {
  field: PropTypes.object,
  disabledField: PropTypes.bool,
};
